"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewShareArrowOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.492 5.78l-1.311.165c-1.474.185-3.044.769-4.278 2.041-.795.82-1.512 1.989-1.956 3.663 1.474-.86 3.436-1.472 6.033-1.487l1.51-.008-.003 2.722 5.009-5.035a.123.123 0 00.004-.038.151.151 0 00-.004-.034L9.495 2.913 9.492 5.78zm-1.505 7.595l.001-1.713a13.82 13.82 0 00-1.5.087c-2.277.262-3.84 1.078-4.914 1.998a7.507 7.507 0 00-1.083 1.147c-.155.202-.501.095-.49-.159a20.352 20.352 0 01.09-1.22 14.7 14.7 0 01.06-.497c.844-6.157 4.68-8.163 7.842-8.561l.002-2.027c0-1.213 1.226-1.873 2.03-1.093l5.534 5.373c.581.564.59 1.597.016 2.173l-5.542 5.572c-.8.804-2.047.146-2.046-1.08z",
    clipRule: "evenodd"
  })))
});
PreviewShareArrowOutlineIcon.displayName = 'PreviewShareArrowOutlineIcon';
var _default = exports.default = PreviewShareArrowOutlineIcon;